import {TypedUseSelectorHook, useSelector} from 'react-redux';
import {RootState} from '../../redux/store/storeTypes';

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export {useAppSelector};
